import { render } from "./Shifts.component.vue?vue&type=template&id=646b63b2"
import script from "./Shifts.component.vue?vue&type=script&lang=js"
export * from "./Shifts.component.vue?vue&type=script&lang=js"

import "./Shifts.component.vue?vue&type=style&index=0&id=646b63b2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QSeparator});
